import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import FullPageLoader from "components/common/FullPageLoader";
import { usePermissions } from "layouts/Admin";
import DynamicGraph2 from "components/main-chart";
import { DashboardSelector } from "slices/dashboardSlice";
import useDashboard from "hooks/useDashboard";
import { Skeleton } from "@mui/material";


const DatesInputs = (({ control, errors }) => {
  const startDateRef = React.useRef(null);
  const endDateRef = React.useRef(null);

  return (
    <>
      <div className="row-primary">
        <h2>Start Date*</h2>
        <Controller
          name="start_date"
          control={control}
          render={({ field }) =>
            <div className="input-image basic_bases">
              <input ref={startDateRef} id='start_date' type="date" name='start_date' placeholder='Start Date'
                {...field}
                value={moment(field.value).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const dateString = moment(new Date(e.target.value)).format('YYYY/MM/DD')
                  field.onChange(dateString)
                }}
              />
              <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

            </div>
          } />
      </div>
      <div className="row-primary">
        <h2>End Date*</h2>
        <Controller
          name="end_date"
          control={control}
          render={({ field }) =>
            <div className="input-image basic_bases">
              <input ref={endDateRef} type="date" name='end_date' placeholder='End Date'
                {...field}
                value={moment(field.value).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const dateString = moment(new Date(e.target.value)).format('YYYY/MM/DD')
                  field.onChange(dateString)
                }}
              />
              <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />
            </div>
          } />
      </div>
    </>
  )
});

function Dashboard() {
  const { checkPermission } = usePermissions()
  const dispatch = useDispatch();
  const { monthWiseSessions, analytics, loader } = useDashboard();
  console.log("monthWiseSessions", analytics);

  useEffect(() => {

  }, [])






  return (
    <>
      <div className="content">
     {loader &&   <FullPageLoader />}

        <div className="row_dash_1">
          <div className="card_table">
            <div className="row_countcard">
              <div className="count-card">
                <div className="count_logo">
                  <img src="/images/Hospital-fill.png" alt="" />
                  <h2>Total Locations</h2>
                </div>
                <div className="count_area">
                  <h2>{analytics?.locations || 0}</h2>
                </div>
              </div>
              <div className="count-card">
                <div className="count_logo">
                  <img src="/images/sessions-fill.png" alt="" />
                  <h2>Total Sessions</h2>
                </div>
                <div className="count_area">
                  <h2>{analytics?.totalSessions || 0}</h2>
                </div>
              </div>
            </div>
          </div>

          <div className="card_table">
            <div className="row_countcard">
              <div className="count-card">
                <div className="count_logo">
                  <img src="/images/Hospital-fill.png" alt="" />
                  <h2>Active Sessions</h2>
                </div>
                <div className="count_area">
                  <h2>{analytics?.activeSessions || 0}</h2>
                </div>
              </div>
              <div className="count-card">
                <div className="count_logo">
                  <img src="/images/sessions-fill.png" alt="" />
                  <h2>Completed Sessions</h2>
                </div>
                <div className="count_area">
                  <h2>{analytics?.completedSessions || 0}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <ScheduleModal /> */}

        <div className="card_table p-5">
          <h1 className="fs-4 fw-semibold mb-5">Month Wise Sessions</h1>
          <DynamicGraph2
            labels={['January', 'Febuary', 'March', "April", "May", "June", "July", "August", "September", "October", "November", "December"]}
            dataPoints={monthWiseSessions}
            chartTitle={"Total Sessions"}
          />
        </div>

      </div>


      {/* {loader && <FullPageLoader />} */}
    </>
  );
}

export default Dashboard;